export default __webpack_public_path__ + "static/media/palette-blue.43aefa8b.svg";